import React, { useState } from "react";
import "../styles/Contact.css";

function Contact() {

const [formData, setFormData] = useState({
name:"",
phone:"",
location:"",
message:""
});

const handleChange = (e) => {
setFormData({...formData, [e.target.name]: e.target.value});
};

const handleSubmit = (e) => {
e.preventDefault();

const {name, phone, location, message} = formData;

const whatsappMessage =
`New Interior Inquiry:
Name: ${name}
Phone: ${phone}
Location: ${location}
Message: ${message}`;

const url =
`https://wa.me/917814719168?text=${encodeURIComponent(whatsappMessage)}`;

window.open(url, "_blank");
};

return (
<>

{/* ===== HERO BANNER ===== */}

<section className="contact-banner">
<div className="banner-overlay">
<h1>Contact Us</h1>
<p>Let’s design your dream space together</p>
</div>
</section>

{/* ===== CONTACT SECTION ===== */}

<section className="contact-section">

<div className="contact-container">

<div className="contact-left">
<h2>Get In Touch</h2>
<p>Contact us for your dream interior design.</p>
</div>

<div className="contact-right">

<h2>Send Message</h2>

<form onSubmit={handleSubmit}>

<input
type="text"
name="name"
placeholder="Your Name"
onChange={handleChange}
required
/>

<input
type="text"
name="phone"
placeholder="Your Phone"
onChange={handleChange}
required
/>

<input
type="text"
name="location"
placeholder="Your Location"
onChange={handleChange}
/>

<textarea
name="message"
placeholder="Your Message"
onChange={handleChange}
/>

<button type="submit">Send Message</button>

</form>

</div>

</div>

</section>

</>
);
}

export default Contact;